

<template>
  <div
    style="border-color: white;"
    :class="`card px-${space} py-${space} mt-${space} wrapper-reviews`"
    v-if="items.length > 0 && items[0].total > 0"
  >
    <div class="col-12" style="display: flex; padding: 0px; max-height: 45px;">
      <div class="col-10" style="padding: 0px;">
        <button
          class="btn col-6 text-left"
          style="box-shadow: none;"
          @click="visible = !visible"
          :class="isPanel ? 'font-size-title': ''"
        >
          {{ this.$t('reports.reviews.reviewsLabel') }}
        </button>
      </div>

      <div class="col-2" style="padding: 0px;">
        <div v-if="!isPanel" class="pull-right" style="display: flex;">
          <div class="custom-switch" style="padding-left: 35px;">
            <div class="col-12">
              <input
                type="checkbox"
                class="custom-control-input"
                id="switch-top2-reviews"
                v-model="top2Selected"
              />
              <label class="custom-control-label" for="switch-top2-reviews" style="white-space: nowrap;">
                Top 2 box score
              </label>
            </div>
          </div>
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible = !visible"
          >
            <i class="fas fa-angle-double-right" v-if="!visible"></i>
            <i v-else class="fas fa-angle-double-down"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div> -->
        <b-table
          :fields="fields"
          :items="[0, 1, 2, 3, 4]"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)>
            <div style="max-width: 85%;">
              <idx-skeleton width="160" height="15" radius="10" class="mt-2" />
            </div>
          </template>
          <template v-slot:cell(progress)>
            <div>
              <div class="row text-right">
                <idx-skeleton
                  width="20"
                  height="20"
                  radius="10"
                  class="mt-2 mr-2 star"
                />
                <idx-skeleton
                  width="20"
                  height="20"
                  radius="20"
                  class="mt-2 mr-2 star"
                />
                <idx-skeleton
                  width="20"
                  height="20"
                  radius="10"
                  class="mt-2 mr-2"
                />
                <idx-skeleton
                  width="20"
                  height="20"
                  radius="10"
                  class="mt-2 mr-2"
                />
                <idx-skeleton
                  width="20"
                  height="20"
                  radius="10"
                  class="mt-2 star"
                />
              </div>
            </div>
          </template>
          <template v-slot:cell(score)>
            <div class="text-right">
              <idx-skeleton
                width="25"
                height="15"
                radius="10"
                class="mt-2 star"
              />
            </div>
          </template>
          <template v-slot:cell(total)>
            <div class="text-center">
              <idx-skeleton width="25" height="15" radius="10" class="mt-2" />
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" id="reviews" class="mt-2">
        <b-table :id="isPanel ? 'size-panels' : ''" :fields="fields" :items="items" caption-bottom sort-icon-left>
          <template v-slot:cell(question)="row">
            <div :style="`max-width: 85%;font-size: ${fontSize}px;`">
              {{ row.item.question }}
            </div>
          </template>
          <template v-slot:cell(progress)="row">
            <div v-if="row.item.type !== 'total'">
              <div>
                <star-rating
                  :increment="0.01"
                  :show-rating="false"
                  :star-size="sizeStar"
                  :read-only="true"
                  :rating="calculateScore(row.item.score)"
                  :padding="5"
                ></star-rating>
              </div>
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div v-if="row.item.type !== 'total'" :style="`font-size: ${fontSize}px;`" class="text-left" >
              {{ showScore(row.item.score) }}
            </div>
          </template>
          <template v-slot:cell(total)="row">
            <div class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.total }}
            </div>
          </template>
          <!-- <template v-slot:table-caption>
            <div class="text-right px-3">
              Total de respostas válidas: {{ total }}
            </div>
          </template> -->
        </b-table>
        <div v-if="!isPanel" class="row">
          <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import starRating from 'vue-star-rating';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import api from '@/services/api';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'ScoreCsat',
  props: ['showCollapsed', 'dataGraph'],
  components: {
    starRating,
    idxSkeleton,
  },
  data: () => ({
    isBusy: false,
    userAuth: null,
    filter: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    reviewsData: [],
    loader: false,
    fields: [],
    items: [],
    totalAnswers: 0,
    lang: 'br',
    top2Selected: false,
    isPanel: true,
    space: 2,
    fontSize: 16,
    sizeStar: 30,
    fontSizeTitle: 16,
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountReview();
    },
    myActionId: function watchMyActionId() {
      this.mountReview();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountReview();
    },
    myIh1: function watchMyIh1() {
      this.mountReview();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.mountReview();
    },
    myIh2: function watchMyIh2() {
      this.mountReview();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.mountReview();
    },
    calendarDates: function watchDates() {
      this.mountReview();
    },
    myMetric: function watchMyMetric() {
      this.mountReview();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.mountReview();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountReview();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountReview();
    },
    top2Selected: function watchTop2Selected() {
      this.mountReview();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountReview() {
      this.loader = true;
      const response = await api.get(`reports/get-reviews`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
          isTop2: this.top2Selected,
        },
      });
      this.reviewsData = response.data;
      this.items = [];
      this.reviewsData.map((obj) => {
        if (obj.question.toLowerCase() === 'total') {
          this.items.push({
            question: this.$t('reports.reviews.totalAnswersLabel'),
            type: 'total',
            total: obj.total,
          });
          this.totalAnswers = obj.total;
          this.total = obj.total;
        } else if (obj.average) {
            this.items.push({
              question: obj.question,
              progress: obj.average,
              score: obj.average.toFixed(2),
              total: obj.total,
            });
          }
        this.sortDesc = true;
        this.isBusy = false;
      });
      this.loader = false;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [
        this.$t('reports.reviews.addQuestionLabel'),
        this.$t('reports.reviews.scoreLabel'),
        this.$t('reports.reviews.totalLabel'),
      ];
      const arr = [];
      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.reviews.addQuestionLabel')]: el.question,
          [this.$t('reports.reviews.scoreLabel')]: el.score,
          [this.$t('reports.reviews.totalLabel')]: el.total,
        });
      });
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-reviews');
      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-reviews'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );
      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-reviews.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    calculateScore(score) {
      if (this.top2Selected) {
        return parseFloat((score / 20).toFixed(2));
      }
      return score;
    },
    showScore(score) {
      if (this.top2Selected) {
        return `${score}%`;
      }
      return score;
    },
    async mountCardPanel(data) {
      this.loader = true;
      const response = await api.get(`reports/get-reviews`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          startDate: '2022-01-01',
          endDate: '2022-07-08',
          ih1: data.ih1 ? data.ih1._id : null,
          // period: data.period ? data.period : null,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          lang: this.lang,
          isTop2: this.top2Selected,
        },
      });
      this.reviewsData = response.data;
      this.items = [];
      this.reviewsData.map((obj) => {
        if (obj.question.toLowerCase() === 'total') {
          this.items.push({
            question: this.$t('reports.reviews.totalAnswersLabel'),
            type: 'total',
            total: obj.total,
          });
          this.totalAnswers = obj.total;
          this.total = obj.total;
        } else {
          this.items.push({
            question: obj.question,
            progress: obj.average,
            score: obj.average,
            total: obj.total,
          });
        }
        this.sortDesc = true;
        this.isBusy = false;
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.reviews.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', class: 'progressTh' },
      {
        key: 'score',
        label: this.$t('reports.reviews.scoreLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: this.$t('reports.reviews.totalLabel'),
        sortable: true,
        class: 'totalTh',
      },
    ];
  },
  async mounted() {
    this.visible = !this.showCollapsed;
    this.lang = this.$i18n.locale;
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);
      this.fontSize = 12;
      this.sizeStar = 20;
      this.fontSizeTitle = 14;
      EventBus.$on('update-review', (items) => {
        this.mountCardPanel(items);
      });
      this.space = 0;
    } else {
      await this.mountReview();
      this.isPanel = false;
      this.fontSize = 16;
      EventBus.$on('filter-rankings', () => {
        this.mountReview();
      });
      this.space = 2;
    }
    EventBus.$emit('loadReview', true);
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-reviews .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-reviews .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
</style>

<style>
table#size-panels{
  font-size: 12px;
}
.font-size-title{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/reviews.vue